<template>
	<div>
		<Titlebar :title="$route.name" />
		<Card>
			<div class="info">
				<p>
					This table shows all IP addresses that are currently blocked or have
					been blocked in the past.
				</p>
			</div>
			<StrapiList source="/blocked-ips">
				<template v-slot="list">
					<BlockedIPsTable v-bind="list" />
				</template>
			</StrapiList>
		</Card>
	</div>
</template>

<script>
import Titlebar from '@/components/admin/Titlebar'
import Card from '@/components/shared/Card'
import StrapiList from '@/components/admin/StrapiList'
import BlockedIPsTable from '@/components/admin/BlockedIPsTable'

export default {
	name: 'BlockedIPs',
	components: {
		Titlebar,
		Card,
		StrapiList,
		BlockedIPsTable
	}
}
</script>

<style lang="scss" scoped>
.info {
	margin-bottom: 2rem;
}
</style>
